import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { SavedViewsQuery } from "lib/generated/app-service-gql/graphql";
import { useSavedViewsDataType } from "lib/hooks/api/saved_views/useSavedViews";
import { SavedViewDataType } from "lib/types/graphQLEnums";
import { SavedViewType, ViewConfigForDataType } from "lib/types/savedViews";

export function useAllViews<D extends SavedViewDataType = SavedViewDataType.Notice>(
  dataType: D,
  options?: UseQueryOptions<SavedViewsQuery, unknown, SavedViewsQuery, QueryKey>,
) {
  const { data, ...rest } = useSavedViewsDataType(
    dataType,
    {},
    { page: 1, pageSize: 1000 },
    options,
  );
  // useSavedViews has already parsed each row's `view` JSON; the rest of the row matches
  // SavedViewType (derived from the same query). The `view` is typed by the dataType `D`.
  const views: SavedViewType<D>[] = (data?.results ?? []).map((view) => ({
    ...view,
    dataType: view.dataType as SavedViewDataType,
    view: view.view as ViewConfigForDataType<D>,
  }));
  return { data: views, ...rest };
}
